import {
  collection,
  getDoc,
  addDoc,
  setDoc,
  updateDoc,
  deleteDoc,
  doc,
  onSnapshot,
  query,
  where,
  Timestamp,
  getDocs,
  orderBy,
  serverTimestamp,
  increment,
  arrayUnion,
  arrayRemove,
} from "firebase/firestore";
import { db, auth } from "./firebase";
import { updateProfile } from "firebase/auth";

// names of firebase collections
const USERS_COLLECTION = "users";
const TEAMS_COLLECTION = "teams";
const ESTIMATES_COLLECTION = "estimates";
const SALESBOARD_COLLECTION = "salesboard";
const PUBLISHED_ESTIMATES_COLLECTION = "publishedEstimates";
const TEMPLATES_COLLECTION = "templates";
const SAVEDTABLEITEMS_COLLECTION = "savedTableItems";

const TEMPORARY_IOS_KAKAO_ESTIMATES_COLLECTION = "iosKakao";

// set initial user information to DB
export const setInitialUserInfoToDB = async ({
  name,
  phoneNumber,
  // companyName,
}) => {
  const user = auth.currentUser;
  try {
    if (user) {
      await setDoc(doc(db, USERS_COLLECTION, user.uid), {
        email: user.email,
        displayName: name,
        companyPhoneNumber: phoneNumber,
        // companyName: companyName,
      });
      updateProfile(user, {
        displayName: name,
      }).then(() => {
        // console.log("profile updated for user cred")
      });
    } else {
      return;
    }
  } catch {
    error;
    toast(error.code, { toastId: "ERROR_UPDATING_USER_INFO" });
  }
};

// update existing user settings
export const updateUserInfoToDB = async ({
  name,
  companyName,
  phoneNumber,
}) => {
  const user = auth.currentUser;
  if (user) {
    await updateDoc(doc(db, USERS_COLLECTION, user.uid), {
      displayName: name,
      companyPhoneNumber: phoneNumber,
    });
    updateProfile(user, {
      displayName: name,
    }).then(() => {
      // console.log("profile updated for user cred")
    });
  } else {
    return;
  }
};

// update user company settings
export const updateUserCompanyInfoToDB = async (userInfo) => {
  const user = auth.currentUser;
  if (user) {
    await updateDoc(doc(db, USERS_COLLECTION, user.uid), {
      companyName: userInfo.companyName,
      companyRegistrationNumber: userInfo.companyRegistrationNumber,
      companyCeoName: userInfo.companyCeoName,
      companyAddress: userInfo.companyAddress,
      companyBizType: userInfo.companyBizClass,
      companyBizClass: userInfo.companyBizType,
    });
  } else {
    return;
  }
};

export const updateTeamCommonSettings = async ({
  companyName,
  companyCeoName,
  companyAddress,
  companyBizClass,
  companyBizType,
  companyBankName,
  companyBankAccountNumber,
  companyLogo,
  companyStamp,
  teamUid,
}) => {
  const user = auth.currentUser;
  if (user) {
    await updateDoc(doc(db, TEAMS_COLLECTION, teamUid), {
      companyName,
      companyCeoName,
      companyAddress,
      companyBizClass,
      companyBizType,
      companyBankName,
      companyBankAccountNumber,
      companyLogo,
      companyStamp,
    });
  } else {
    return;
  }
};

const regularDateToFirebaseDate = (date) => {
  return Timestamp.fromDate(date);
};

// posts estimate data to temporary IOS Kakao InappBrowser DB
export const postEstimateToTemporaryDBAndReturnUid = async ({
  companyName,
  companyCeoName,
  companyAddress,
  companyRepresentative,
  companyPhoneNumber,
  companyLogo,
  companyStamp,
  customerCompany,
  customerName,
  tableInfo,
  tableTotalCost,
  estimateName,
  estimateDate,
  estimateNumber,
  estimateExtra,
}) => {
  const docRef = await addDoc(
    collection(db, TEMPORARY_IOS_KAKAO_ESTIMATES_COLLECTION),
    {
      companyName: companyName,
      companyCeoName: companyCeoName,
      companyAddress: companyAddress,
      companyRepresentative: companyRepresentative,
      companyPhoneNumber: companyPhoneNumber,
      companyLogo: companyLogo,
      companyStamp: companyStamp,
      customerCompany: customerCompany,
      customerName: customerName,
      tableInfo: tableInfo,
      tableTotalCost: tableTotalCost,
      estimateName: estimateName,
      estimateDate: estimateDate,
      estimateNumber: estimateNumber,
      estimateExtra: estimateExtra,
    }
  );
  const estimateUid = docRef.id;
  return estimateUid;
};

// posts estimate data to DB
export const postEstimateToDB = async ({
  companyName,
  companyCeoName,
  companyAddress,
  companyRepresentative,
  companyPhoneNumber,
  companyLogo,
  companyStamp,
  customerCompany,
  customerName,
  tableInfo,
  tableTotalCost,
  estimateName,
  estimateDate,
  estimateNumber,
  estimateExtra,
}) => {
  const user = auth.currentUser;
  const createdTime = serverTimestamp();
  if (user) {
    if (estimateName === "") {
      await addDoc(collection(db, ESTIMATES_COLLECTION), {
        uid: user.uid,
        companyName: companyName,
        companyCeoName: companyCeoName,
        companyAddress: companyAddress,
        companyRepresentative: companyRepresentative,
        companyPhoneNumber: companyPhoneNumber,
        companyLogo: companyLogo,
        companyStamp: companyStamp,
        customerCompany: customerCompany,
        customerName: customerName,
        tableInfo: tableInfo,
        tableTotalCost: tableTotalCost,
        estimateName: "견적서 이름이 없습니다",
        estimateDate: estimateDate,
        estimateNumber: estimateNumber,
        estimateExtra: estimateExtra,
        createdTime: createdTime,
      });
    } else {
      await addDoc(collection(db, ESTIMATES_COLLECTION), {
        uid: user.uid,
        companyName: companyName,
        companyCeoName: companyCeoName,
        companyAddress: companyAddress,
        companyRepresentative: companyRepresentative,
        companyPhoneNumber: companyPhoneNumber,
        companyLogo: companyLogo,
        companyStamp: companyStamp,
        customerCompany: customerCompany,
        customerName: customerName,
        tableInfo: tableInfo,
        tableTotalCost: tableTotalCost,
        estimateName: estimateName,
        estimateDate: estimateDate,
        estimateNumber: estimateNumber,
        estimateExtra: estimateExtra,
        createdTime: createdTime,
      });
    }
  } else {
    return;
  }
};

// posts salesboard info data to DB (setting)
export const postSalesboardInfo = async ({
  salesboardUid,
  salesboardName,
  supplier,
  customerUid,
  customer,
  supplierCompanyLogo,
  supplierCompanyStamp,
}) => {
  const createdTime = serverTimestamp();
  const user = auth.currentUser;
  if (user) {
    await setDoc(doc(db, SALESBOARD_COLLECTION, salesboardUid), {
      ownerUid: user.uid,
      ownerEmail: user.email,
      createdTime: createdTime,
      lastEdited: createdTime,
      salesboardName: salesboardName,
      supplier: supplier,
      customerUid: customerUid,
      customer: customer,
      supplierCompanyLogo: supplierCompanyLogo,
      supplierCompanyStamp: supplierCompanyStamp,
    });
  }
};

// updates existing salesboard data (setting)
export const updateSalesboard = async ({
  salesboardUid,
  salesboardName,
  supplier,
  customerUid,
  customer,
  supplierCompanyLogo,
  supplierCompanyStamp,
}) => {
  // const createdTime = serverTimestamp();
  const user = auth.currentUser;
  if (user) {
    await updateDoc(doc(db, SALESBOARD_COLLECTION, salesboardUid), {
      // lastEdited: createdTime,
      salesboardName: salesboardName,
      supplier: supplier,
      customerUid: customerUid,
      customer: customer,
      supplierCompanyLogo: supplierCompanyLogo,
      supplierCompanyStamp: supplierCompanyStamp,
    });
  }
};

// posts salesboard data to DB (editor)
export const saveSalesboardToDB = async (
  salesboardUid,
  estimates,
  lastEdited
) => {
  const createdTime = serverTimestamp();
  const user = auth.currentUser;
  if (user) {
    await setDoc(doc(db, SALESBOARD_COLLECTION, salesboardUid), {
      ownerUid: user.uid,
      ownerEmail: user.email,
      lastEdited: lastEdited,
      createdTime: createdTime,
      estimates: estimates,
    });
  }
};

// updates existing salesboard data to DB
export const updateSalesboardToDB = async (
  salesboardUid,
  estimateObjectToAdd
) => {
  const createdTime = serverTimestamp();
  const user = auth.currentUser;
  if (user) {
    await updateDoc(doc(db, SALESBOARD_COLLECTION, salesboardUid), {
      lastEdited: createdTime,
      estimates: arrayUnion(estimateObjectToAdd),
    });
  }
};

// updates dealConfig salesboard data to DB
export const updateDealConfig = async (salesboardUid, estimateObjectToAdd) => {
  const createdTime = serverTimestamp();
  const user = auth.currentUser;
  if (user) {
    await updateDoc(doc(db, SALESBOARD_COLLECTION, salesboardUid), {
      lastEdited: createdTime,
      dealConfig: estimateObjectToAdd,
      dealConfigPaymentImported: false,
      // acceptedDate: createdTime,
    });
  }
};

// updates dealConfig paymentInfo salesboard data to DB
export const updateImportedDealConfig = async (salesboardUid) => {
  const user = auth.currentUser;
  if (user) {
    await updateDoc(doc(db, SALESBOARD_COLLECTION, salesboardUid), {
      dealConfigPaymentImported: true,
    });
  }
};

// updates salesboard with customer company info (공급받는자 사업자등록 정보)
export const saveCustomerInfoToSalesboard = async (
  salesboardUid,
  taxFormReceivingEmail
) => {
  const user = auth.currentUser;
  if (user) {
    await updateDoc(doc(db, SALESBOARD_COLLECTION, salesboardUid), {
      taxFormReceivingEmail: taxFormReceivingEmail,
    });
  }
};

// get salesboard if exists
export const getSalesboard = async (salesboardUid) => {
  const salesboardRef = doc(db, SALESBOARD_COLLECTION, salesboardUid);
  const estimateSnap = await getDoc(salesboardRef);
  if (!estimateSnap.data()) {
    return false;
  }
  return estimateSnap;
};

// make salesboard 확정
export const acceptPublicSalesboard = async (
  salesboardUid,
  estimateObjectToAdd
) => {
  await updateDoc(doc(db, SALESBOARD_COLLECTION, salesboardUid), {
    estimates: arrayUnion(estimateObjectToAdd),
  });
};

export const unacceptPublicSalesboard = async (
  salesboardUid,
  estimateObjectToAdd
) => {
  await updateDoc(doc(db, SALESBOARD_COLLECTION, salesboardUid), {
    estimates: arrayUnion(estimateObjectToAdd),
  });
};

export const incrementPublicSalesboardView = async (salesboardUid) => {
  await updateDoc(doc(db, SALESBOARD_COLLECTION, salesboardUid), {
    numAccessed: increment(1),
  });
};

// updating customer tax info
export const updateSalesboardTaxInfo = async (salesboardUid, taxInfo) => {
  await updateDoc(doc(db, SALESBOARD_COLLECTION, salesboardUid), {
    taxInfo: taxInfo,
  });
};

// updating tax form info
export const updateSalesboardTaxForms = async (salesboardUid, taxForm) => {
  await updateDoc(doc(db, SALESBOARD_COLLECTION, salesboardUid), {
    taxForms: taxForm,
  });
};

// update salesboard password
export const updateSalesboardPassword = async (salesboardUid, password) => {
  await updateDoc(doc(db, SALESBOARD_COLLECTION, salesboardUid), {
    password: password,
  });
};

// delete salesboard password
export const deleteSalesboardPassword = async (salesboardUid) => {
  await updateDoc(doc(db, SALESBOARD_COLLECTION, salesboardUid), {
    password: "",
  });
};

// deletes salesboard from DB
export const deleteSalesboardFromDB = async (salesboardUid) => {
  await deleteDoc(doc(db, SALESBOARD_COLLECTION, salesboardUid));
};

// create new doc
export const createNewDocAndReturnRef = async () => {
  const user = auth.currentUser;
  if (user) {
    const collectionRef = collection(db, SALESBOARD_COLLECTION);
    const docRef = doc(collectionRef);
    return docRef;
  }
};

// updates existing estimate with new estimate data to DB
export const updateExistingEstimateToDB = async (
  companyName,
  companyCeoName,
  companyAddress,
  companyRepresentative,
  companyPhoneNumber,
  companyLogo,
  companyStamp,
  customerCompany,
  customerName,
  tableInfo,
  tableTotalCost,
  estimateName,
  estimateDate,
  estimateNumber,
  estimateExtra,
  estimateId
) => {
  await updateDoc(doc(db, ESTIMATES_COLLECTION, estimateId), {
    companyName: companyName,
    companyCeoName: companyCeoName,
    companyAddress: companyAddress,
    companyRepresentative: companyRepresentative,
    companyPhoneNumber: companyPhoneNumber,
    companyLogo: companyLogo,
    companyStamp: companyStamp,
    customerCompany: customerCompany,
    customerName: customerName,
    tableInfo: tableInfo,
    tableTotalCost: tableTotalCost,
    estimateName: estimateName,
    estimateDate: estimateDate,
    estimateNumber: estimateNumber,
    estimateExtra: estimateExtra,
  });
};

// deletes estimate from DB
export const deleteEstimateFromDB = async (estimateId) => {
  await deleteDoc(doc(db, ESTIMATES_COLLECTION, estimateId));
};

// 출시 - posts a public published estimate to DB
export const postPublishedEstimateToDB = async (
  companyName,
  companyCeoName,
  companyAddress,
  companyRepresentative,
  companyPhoneNumber,
  companyLogo,
  companyStamp,
  customerCompany,
  customerName,
  tableInfo,
  tableTotalCost,
  estimateName,
  estimateDate,
  estimateNumber,
  estimateExtra,
  estimateUid,
  isPublic
) => {
  const user = auth.currentUser;
  if (user) {
    await addDoc(collection(db, PUBLISHED_ESTIMATES_COLLECTION), {
      ownerUid: user.uid,
      ownerEmail: user.email,
      companyName: companyName,
      companyCeoName: companyCeoName,
      companyAddress: companyAddress,
      companyRepresentative: companyRepresentative,
      companyPhoneNumber: companyPhoneNumber,
      companyLogo: companyLogo,
      companyStamp: companyStamp,
      customerCompany: customerCompany,
      customerName: customerName,
      tableInfo: tableInfo,
      tableTotalCost: tableTotalCost,
      estimateName: estimateName,
      estimateDate: estimateDate,
      estimateNumber: estimateNumber,
      estimateExtra: estimateExtra,
      estimateUid: estimateUid,
      isPublic: isPublic,
    });
  } else {
    return;
  }
};

// updates existing public published estimate with new estimate data
export const updatePublishedEstimateToDB = async (
  companyName,
  companyCeoName,
  companyAddress,
  companyRepresentative,
  companyPhoneNumber,
  companyLogo,
  companyStamp,
  customerCompany,
  customerName,
  tableInfo,
  tableTotalCost,
  estimateName,
  estimateDate,
  estimateNumber,
  estimateExtra,
  estimateUid,
  isPublic,
  publishedEstimateUid
) => {
  const user = auth.currentUser;
  if (user) {
    await setDoc(
      doc(db, PUBLISHED_ESTIMATES_COLLECTION, publishedEstimateUid),
      {
        ownerUid: user.uid,
        ownerEmail: user.email,
        companyName: companyName,
        companyCeoName: companyCeoName,
        companyAddress: companyAddress,
        companyRepresentative: companyRepresentative,
        companyPhoneNumber: companyPhoneNumber,
        companyLogo: companyLogo,
        companyStamp: companyStamp,
        customerCompany: customerCompany,
        customerName: customerName,
        tableInfo: tableInfo,
        tableTotalCost: tableTotalCost,
        estimateName: estimateName,
        estimateDate: estimateDate,
        estimateNumber: estimateNumber,
        estimateExtra: estimateExtra,
        estimateUid: estimateUid,
        isPublic: isPublic,
      }
    );
  } else {
    return;
  }
};

// get published estimate from DB if exists
// @estimateUid - uid of the original estimate
export const getPublishedEstimateFromDB = async (
  estimateUid,
  setPublishedEstimate,
  setShowPublicURL
) => {
  const publishedCollection = collection(db, PUBLISHED_ESTIMATES_COLLECTION);
  const q = query(publishedCollection, where("estimateUid", "==", estimateUid));
  onSnapshot(q, (snapshot) => {
    const resultDoc = snapshot.docs.map((doc) => {
      return {
        id: doc.id,
        data: {
          ownerUid: doc.data().ownerUid,
          ownerEmail: doc.data().ownerEmail,
          companyName: doc.data().companyName,
          companyCeoName: doc.data().companyCeoName,
          companyAddress: doc.data().companyAddress,
          companyRepresentative: doc.data().companyRepresentative,
          companyPhoneNumber: doc.data().companyPhoneNumber,
          companyLogo: doc.data().companyLogo,
          companyStamp: doc.data().companyStamp,
          customerCompany: doc.data().customerCompany,
          customerName: doc.data().customerName,
          tableInfo: doc.data().tableInfo,
          tableTotalCost: doc.data().tableTotalCost,
          estimateName: doc.data().estimateName,
          estimateDate: doc.data().estimateDate,
          estimateNumber: doc.data().estimateNumber,
          estimateExtra: doc.data().estimateExtra,
          estimateUid: doc.data().estimateUid,
          isPublic: doc.data().isPublic,
        },
      };
    });
    if (resultDoc[0]) {
      setPublishedEstimate(resultDoc[0]);
      setShowPublicURL(resultDoc[0].data.isPublic);
    }
  });
};

// get published public estimate if exists
export const getPublicEstimate = async (estimateUid) => {
  const publishedDoc = doc(db, PUBLISHED_ESTIMATES_COLLECTION, estimateUid);
  const estimateSnap = await getDoc(publishedDoc);
  if (!estimateSnap.data() || !estimateSnap.data().isPublic) {
    return false;
  }
  return estimateSnap;
};

// updates public esimtate
export const updatePublicEstimate = async (estimateUid, isAccepted) => {
  await updateDoc(doc(db, PUBLISHED_ESTIMATES_COLLECTION, estimateUid), {
    isAccepted: isAccepted,
  });
};

// unpublishes (deletes) public published estimate (currently unused)
export const deletePublicEstimate = async (estimateUid) => {
  await deleteDoc(doc(db, PUBLISHED_ESTIMATES_COLLECTION, estimateUid));
};

export const updateCommentsToDB = async (salesboardUid, comments) => {
  await updateDoc(doc(db, SALESBOARD_COLLECTION, salesboardUid), {
    comments: comments,
  });
};

// get templates
export const getTemplates = async (ownerUids) => {
  const q = query(
    collection(db, TEMPLATES_COLLECTION),
    where("ownerUid", "in", ownerUids),
    orderBy("createdTime", "desc")
  );

  const querySnapshot = await getDocs(q);

  const allTemplates = [];

  querySnapshot.forEach((doc) => {
    allTemplates.push(doc);
  });
  return allTemplates;
};

// post template
export const postTemplateToDB = async (
  templateName,
  {
    companyName,
    companyCeoName,
    companyAddress,
    companyRepresentative,
    companyPhoneNumber,
    companyLogo,
    companyStamp,
    customerCompany,
    customerName,
    tableInfo,
    estimateName,
    estimateDate,
    estimateNumber,
    estimateExtra,
  }
) => {
  const user = auth.currentUser;
  const createdTime = regularDateToFirebaseDate(new Date());
  if (user) {
    await addDoc(collection(db, TEMPLATES_COLLECTION), {
      uid: user.uid,
      templateName: templateName,
      companyName: companyName,
      companyCeoName: companyCeoName,
      companyAddress: companyAddress,
      companyRepresentative: companyRepresentative,
      companyPhoneNumber: companyPhoneNumber,
      companyLogo: companyLogo,
      companyStamp: companyStamp,
      customerCompany: customerCompany,
      customerName: customerName,
      tableInfo: tableInfo,
      estimateName: estimateName,
      estimateDate: estimateDate,
      estimateNumber: estimateNumber,
      estimateExtra: estimateExtra,
      createdTime: createdTime,
    });
  } else {
    return;
  }
};

// updates existing template with new template data to DB
export const updatingExistingTemplateToDB = async (
  templateName,
  templateId,
  {
    companyName,
    companyCeoName,
    companyAddress,
    companyRepresentative,
    companyPhoneNumber,
    companyLogo,
    companyStamp,
    customerCompany,
    customerName,
    tableInfo,
    tableTotalCost,
    estimateName,
    estimateDate,
    estimateNumber,
    estimateExtra,
  }
) => {
  await updateDoc(doc(db, TEMPLATES_COLLECTION, templateId), {
    templateName: templateName,
    companyName: companyName,
    companyCeoName: companyCeoName,
    companyAddress: companyAddress,
    companyRepresentative: companyRepresentative,
    companyPhoneNumber: companyPhoneNumber,
    companyLogo: companyLogo,
    companyStamp: companyStamp,
    customerCompany: customerCompany,
    customerName: customerName,
    tableInfo: tableInfo,
    tableTotalCost: tableTotalCost,
    estimateName: estimateName,
    estimateDate: estimateDate,
    estimateNumber: estimateNumber,
    estimateExtra: estimateExtra,
  });
};

// update only the name of template
export const updateExistingTemplateName = async (templateName, templateId) => {
  await updateDoc(doc(db, TEMPLATES_COLLECTION, templateId), {
    templateName: templateName,
  });
};

// deletes template from DB
export const deleteTemplateFromDB = async (templateId) => {
  await deleteDoc(doc(db, TEMPLATES_COLLECTION, templateId));
};

// get saved table items from DB
export const getSavedTableItems = async (ownerUids) => {
  const q = query(
    collection(db, SAVEDTABLEITEMS_COLLECTION),
    where("uid", "in", ownerUids)
  );
  const querySnapshot = await getDocs(q);

  const tableItems = [];
  querySnapshot.forEach((doc) => {
    tableItems.push(doc);
  });
  return tableItems[0];
};

// post saved table item to DB
export const postSavedTableItemToDB = async (tableInfo) => {
  const user = auth.currentUser;
  if (user) {
    await addDoc(collection(db, SAVEDTABLEITEMS_COLLECTION), {
      uid: user.uid,
      tableInfo: tableInfo,
    });
  } else {
    return;
  }
};

// updates existing saved table items with new template data to DB
export const updateExistingSavedTableItemsToDB = async (
  tableInfo,
  tableInfoId
) => {
  await updateDoc(doc(db, SAVEDTABLEITEMS_COLLECTION, tableInfoId), {
    tableInfo: tableInfo,
  });
};

// deletes saved table item from DB
export const deleteSavedTableItemFromDB = async (tableInfoId) => {
  await deleteDoc(doc(db, SAVEDTABLEITEMS_COLLECTION, tableInfoId));
};
